module.exports = __webpack_public_path__ + "static/media/stockage.560045bf.jpg";